import { LocationType } from "./Enums";

export class ContractParameters {
    locCode: string = '';
    locationType: LocationType = LocationType.Origin;
    commodityCode: string = '';
    locationId: number = 0;
    customerId: number = 0;
    deliveryTerm: string = '';
    shipThroughDate: string = '';
    customerName: string = '';
    locationName: string = '';
    locationCity: string = '';
    commodity: string = '';
}